<template>
  <div class="VB_Error VB_Error--500">
    <div>
      <h2>
        Sorry! There was an error
      </h2>
      <p>
        Sorry, for some reason we couldn't access the requested brochure's
        information right now. Please refresh the page to try again. If you
        continue to experience this error, please contact ViewMedica support.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewmedicaBrochure500"
};
</script>
